import React, { lazy, Suspense, Fragment } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ThemeProvider } from '@material-ui/styles';
import { BounceLoader } from 'react-spinners';
import MuiTheme from './theme';
import { PresentationLayout } from './layouts';
import Signin from './pages/signin';
import Register from './pages/register';
import ForgotPassword from './pages/forgot-password';
import CompanyRoute from './routes/compnay';
import VendorRoute from './routes/vendor';
import SignOut from './routes/signout';
import { ROUTES_PATH_CONFIG } from './config/routes';
import NotFound from './routes/not_found';
import AppGlobalAlert from './components/app_global_alert';
import AppGlobalLoader from './components/app_global_loader';

const Routes = () => {
    const location = useLocation();

    const pageVariants = {
        initial: {
            opacity: 0,
            scale: 0.99
        },
        in: {
            opacity: 1,
            scale: 1
        },
        out: {
            opacity: 0,
            scale: 1.01
        }
    };

    const pageTransition = {
        type: 'tween',
        ease: 'anticipate',
        duration: 0.4
    };

    const SuspenseLoading = () => {
        return (
            <Fragment>
                <div className="d-flex align-items-center flex-column vh-100 
                               justify-content-center text-center py-3">
                    <div className="d-flex align-items-center flex-column px-4">
                        <BounceLoader color={'#5383ff'} loading={true} />
                    </div>
                    <div className="text-muted font-size-xl text-center pt-3">
                        Please wait while we load the page ....
                    </div>
                </div>
            </Fragment>
        );
    };

    return (
        <ThemeProvider theme={MuiTheme}>
            <AppGlobalAlert/>
            <AppGlobalLoader/>
            <AnimatePresence>
                <Suspense fallback={<SuspenseLoading />}>
                    <Switch>
                        <Redirect exact from="/" to={ROUTES_PATH_CONFIG.APP.signin} />
                        <Route path={[
                            ROUTES_PATH_CONFIG.APP.signin,
                            ROUTES_PATH_CONFIG.APP.register,
                            ROUTES_PATH_CONFIG.APP.forgot_password,
                            ROUTES_PATH_CONFIG.APP.signout]}>
                            <PresentationLayout>
                                <Switch location={location} key={location.pathname}>
                                    <motion.div
                                        initial="initial"
                                        animate="in"
                                        exit="out"
                                        variants={pageVariants}
                                        transition={pageTransition}>
                                        <Route path={ROUTES_PATH_CONFIG.APP.signin} component={Signin} />
                                        <Route path={ROUTES_PATH_CONFIG.APP.register} component={Register} />
                                        <Route path={ROUTES_PATH_CONFIG.APP.forgot_password} component={ForgotPassword} />
                                        <Route path={ROUTES_PATH_CONFIG.APP.signout} component={SignOut} />
                                    </motion.div>
                                </Switch>
                            </PresentationLayout>
                        </Route>
                        <VendorRoute path={[
                            ROUTES_PATH_CONFIG.VENDOR.dashboard,
                            ROUTES_PATH_CONFIG.VENDOR.profile,
                            ROUTES_PATH_CONFIG.VENDOR.rates,
                            ROUTES_PATH_CONFIG.VENDOR.all_posts,
                            ROUTES_PATH_CONFIG.VENDOR.applied_posts,
                            ROUTES_PATH_CONFIG.VENDOR.rfqs,
                            ROUTES_PATH_CONFIG.VENDOR.meeting_invites,
                            ROUTES_PATH_CONFIG.VENDOR.subscription,
                        ]} />
                        <CompanyRoute path={[
                            ROUTES_PATH_CONFIG.COMPANY.dashboard,
                            ROUTES_PATH_CONFIG.COMPANY.profile,
                            ROUTES_PATH_CONFIG.COMPANY.change_password,
                            ROUTES_PATH_CONFIG.COMPANY.users,
                            ROUTES_PATH_CONFIG.COMPANY.contractors,
                            ROUTES_PATH_CONFIG.COMPANY.rfq,
                            ROUTES_PATH_CONFIG.COMPANY.work_posts,
                            ROUTES_PATH_CONFIG.COMPANY.meeting_schedules,
                            ROUTES_PATH_CONFIG.COMPANY.subscription,
                        ]}
                        />
                        <Route component={NotFound} />
                    </Switch>
                </Suspense>
            </AnimatePresence>
        </ThemeProvider>);
};

export default Routes;